<template>
  <Popover ref="popover" :showHeader="true" :headerTitle="title" sizeClass="popover-medium">
    <div class="p-2">
      <LoadingPanel :loading="loading" />
      <div v-if="!loading">
        <div class="font-weight-bold">Last Location Update</div>
        <div>{{formatDateTime(user.locationLastUpdate)}}</div>
      </div>
      <div v-if="hasTask">
        <div class="font-weight-bold">Current Task</div>
        <div><LinkTask :id="task.id" :name="task.name" /></div>
        <div class="font-weight-bold" v-if="taskInfoDescription">Task Info</div>
        <div>{{taskInfoDescription}}</div>
      </div>
    </div>
  </Popover>
</template>

<script>
import moment from 'moment'
import Popover from '@/components/popover'

import { TaskStatusTypes, TaskItemStatusTypes } from '@/store/types'

export default {
  name: 'MapUserPopover',
  components: {
    Popover
  },
  data() {
    return {
      loading: false,
      task: {},
      user: {}
    }
  },
  computed: {
    title() {
      if(this.user) {
        return this.user.name
      }
      return 'User'
    },
    hasTask() {
      return !!this.task.id
    },
    taskInfoDescription() {
      if(this.task.status == TaskStatusTypes.completed) {
        if(!this.task.routeEndLocationArrived)
          return `Driving back`
        return ''
      }
        
      if(this.task.status == TaskStatusTypes.loading)
        return 'Loading'
      if(this.task.status == TaskStatusTypes.ready || this.task.status == TaskStatusTypes.inProgress) {
        // Get next task item
        let activeTaskItem = this.task.taskItems.find(taskItem => taskItem.status == TaskItemStatusTypes.active)
        if(activeTaskItem) {
          if(activeTaskItem.isResourceArrived)
            return `At ${activeTaskItem.name}`
          if(activeTaskItem.estimatedArrivalDate)
            return `On the way to ${activeTaskItem.name}, expected at ${this.formatTime(activeTaskItem.estimatedArrivalDate)}`
          return `On the way to ${activeTaskItem.name}`
        }
        
        return 'On Route'
      }

      return ''
    }
  },
  methods: {
    displayFromElement(element, user) {
      this.$refs.popover.displayFromElement(element)

      // Reset
      this.user = user
      this.task = {}

      // Load active delivery tasks & find out relevant task info with this user as the primary user
      this.loading = true
      this.$apiService.tasksService.getActiveTasksList()
      .then(response => {
        // Get first task that matches up
        // Try active tasks first, then recently completed
        let taskList = response.data.filter(task => task.primaryUserId == this.user.id && task.taskType.isLocationTrackingEnabled)
        let activeTask = taskList.find(task => task.status == TaskStatusTypes.loading || task.status == TaskStatusTypes.inProgress)
        if(!activeTask)
          activeTask = taskList.find(task => task.status == TaskStatusTypes.completed)

        this.task = activeTask
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>